import api from '../api';

export const scanDocumentIA = async (file, onProgress) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/ai/scan-document', formData, { 
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erreur api scanDocumentIA :", error);
    return { 
      success: false, 
      error: error.response?.data?.error || "Erreur de connexion au serveur IA." 
    };
  }
};

export const exportAIData = async (format, data) => {
  try {
    const response = await api.post(`/ai/export-${format}`, { data }, { 
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    let extension = format;
    if (format === 'excel') extension = 'xlsx';
    if (format === 'word') extension = 'docx';
    
    link.setAttribute('download', `Export_IA.${extension}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    return { success: true };
  } catch (error) {
    console.error(`Erreur export ${format}:`, error);
    return { success: false, error: "Erreur lors de l'exportation." };
  }
};
